import React from "react"
import Container from "src/components/Container/Container"
import "./MidGame.scss"
import Stepper from "src/components/Stepper/Stepper"
import Button from "src/components/Button/Button"
import SnowLines from "src/components/SnowLines/SnowLines"
import { useSessionContext } from "src/hooks"
import { useGetMidGameConfiguration } from "src/pages/MidGame/hooks"
import { Link, useNavigate } from "react-router"
import ArrrAgency from "src/components/ArrrAgency/ArrrAgency"
import { ButtonVariantsEnum } from "src/components/Button/types"
import ym from "react-yandex-metrika"
import { downloadDocument, runTypograph } from "src/helpers"
import Markdown from "react-markdown"
import rehypeRaw from "rehype-raw"

const MidGame = () => {
    const { currentRound, recalculate, rounds, currentCompany } = useSessionContext()
    const { type, configuration } = useGetMidGameConfiguration()
    const navigate = useNavigate()

    if (!configuration) {
        return null
    }

    const isFinalRound = currentRound === 5
    const isFormSent = localStorage.getItem("danetki-send")

    return (
        <div className={"mid-game"}>
            <Container
                containerOuterClassName={"mid-game__top-outer-container"}
                containerInnerClassName={"mid-game__top-inner-container"}
            >
                <Stepper step={currentRound - 1}/>
            </Container>
            <Container
                containerOuterClassName={"mid-game__middle-outer-container"}
                containerInnerClassName={"mid-game__middle-inner-container"}
            >
                <div className={"mid-game__image-container"}>
                    <img className={"mid-game__image"} src={configuration.image} alt=""/>
                    <SnowLines
                        isIndex={true}
                        backClassName={"mid-game__snow-lines--back"}
                        frontClassName={"mid-game__snow-lines--front"}
                    />
                </div>
            </Container>
            <Container
                containerOuterClassName={"mid-game__bottom-outer-container"}
                containerInnerClassName={"mid-game__bottom-inner-container"}
            >
                <Markdown className={"heading h1 center"} rehypePlugins={[rehypeRaw]}>
                    {configuration.heading}
                </Markdown>
                <Markdown
                    className={"paragraph paragraph--1 mid-game__description center"}
                >
                    {runTypograph(configuration.description)}
                </Markdown>
                <div
                    className={`mid-game__button-container mid-game__button-container--${
                        currentRound === 4 && rounds[currentRound - 1] !== "h" && "short"
                    }`}
                >
                    {configuration.button ? (
                        <Button
                            variant={ButtonVariantsEnum.SECONDARY}
                            className={"special-button"}
                            onClick={() => {
                                console.log('type', type)
                                console.log('currentRound', currentRound )
                                console.log('currentCompany', currentCompany )
                                ym('reachGoal', `download-${type}-materials`)
                            }}
                        >
                            <Link
                                className={"special-link"}
                                to={`/${configuration?.button?.link}`}
                                target={"_blank"}

                            >
                                <span>{configuration.button.text}</span>
                                <img src="/misc/download-icon.svg" alt=""/>
                            </Link>
                        </Button>
                    ) : null}
                    {isFinalRound ? (
                        <>
                            {isFormSent ? (
                                <Button
                                    onClick={() => {
                                        recalculate()
                                        navigate("/game")
                                    }}
                                    variant={ButtonVariantsEnum.TERTIARY}
                                >
                                    Играть ещё
                                </Button>
                            ) : (
                                <Button
                                    onClick={() => {
                                        ym("reachGoal", "page-visit-form")
                                        navigate("/form")
                                    }}
                                    variant={ButtonVariantsEnum.TERTIARY}
                                >
                                    Оставить контакты
                                </Button>
                            )}
                        </>
                    ) : (
                        <Button
                            onClick={() => {
                                navigate("/game")
                            }}
                            variant={ButtonVariantsEnum.TERTIARY}
                            className={
                                currentRound === 4 && rounds[currentRound - 1] !== "h"
                                    ? "mid-game__button--short"
                                    : ""
                            }
                        >
                            <span>Играть дальше</span>
                            <img src="/misc/button-right-arrow.png" alt=""/>
                        </Button>
                    )}
                </div>
                <div className={"mid-game__arrr"}>
                    <ArrrAgency/>
                </div>
            </Container>
        </div>
    )
}

export default MidGame
